import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Query } from "react-apollo";
import { gql } from "apollo-boost";
import find from "lodash/find";
import orderBy from "lodash/orderBy";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import BasicCard from "../BasicCard";
import Loader from "../Loader";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(1)
    },
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1)
    }
  },
  grid: {
    [theme.breakpoints.up("md")]: {
      justifyContent: "center"
    }
  }
}));

function ChooseSystem({
  defaultSystem,
  focus,
  label,
  locale,
  onSelect,
  materialId,
  productId,
  selectedSystem,
  setSelectedSystem
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Query query={SYSTEMS_QUERY} variables={{ locale, materialId, productId }}>
      {({ data, loading, error, refetch }) => {
        if (loading) {
          return (
            <div className="flex w-100">
              <Loader />
            </div>
          );
        }

        if (error) {
          return (
            <div className="flex w-100">
              <div>{t("root.error")}</div>
            </div>
          );
        }

        const options = orderBy(
          data.systems.map(({ id, name, image }) => ({
            id,
            name,
            image,
            translation: t(`names.systems.${name}`)
          })),
          "translation",
          "asc"
        );

        // const defaultValue = defaultSystem
        //   ? find(
        //       options,
        //       ({ translation }) => translation === defaultSystem.translation
        //     )
        //   : null;
        //
        // if (defaultValue && !selectedSystem) {
        //   setSelectedSystem(defaultValue);
        //   if (onSelect) onSelect();
        // }

        return (
          <>
            <h2>{t("categories.system")}</h2>
            <div className={classes.root}>
              <Grid className={classes.grid} container spacing={3}>
                {options.map(({ id, name, image }) => (
                  <Grid item>
                    <BasicCard
                      id={id}
                      image={image && `/img/systems/${image}`}
                      name={t(`names.systems.${name}`)}
                      onSelect={() => {
                        setSelectedSystem({
                          id,
                          name,
                          image: image && `/img/types/${image}`
                        });
                        if (onSelect) onSelect();
                      }}
                      selected={
                        selectedSystem &&
                        selectedSystem.id &&
                        selectedSystem.id === id
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          </>
        );
      }}
    </Query>
  );
}

export const SYSTEMS_QUERY = gql`
  query SystemsQuery($locale: String!, $materialId: ID, $productId: ID) {
    systems(locale: $locale, materialId: $materialId, productId: $productId) {
      id
      name
      image
    }
  }
`;

export default ChooseSystem;
